import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React, { useEffect, useState } from "react";
import { useAppDispatch } from "src/app-redux/hooks";
import { getYardAction } from "src/app-redux/insights/actions/insightsActions";
import { IYardInsights } from "src/common/typings/insights";

interface Props {
  startDate: string;
  endDate: string;
}

ChartJS.register(ArcElement, Tooltip, Legend);

const useStyles = makeStyles(() => ({
  vehiclesItem: {
    border: "0.5px solid #E6E6E6",
    borderRadius: "8px",
    boxShadow: "0px 0px 2px #00000029",
    padding: "15px 15px 15px 15px",
    margin: "8px 0px 8px 0px",
  },
}));

export function Yard({ startDate, endDate }: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [responseYards, setResponseYards] = useState<any>([]);
  const emptyColor = "#E0E0E0";
  const [colors, setColors] = useState<any>([]);

  const getNewColorCode: any = () => {
    const colorCode = `#${Math.floor(Math.random() * 0xffffff).toString(16)}`;
    return colorCode.length == 7 ? colorCode : getNewColorCode();
  };

  useEffect(() => {
    getYardInsight(startDate, endDate);
  }, [startDate, endDate]);

  const getYardInsight = async (startDate: string, endDate: string) => {
    const req: IYardInsights = {
      startDate: startDate,
      endDate: endDate,
    };
    const res = await dispatch(getYardAction(req));

    if (res.payload) {
      const colors = res?.payload?.yards.map(() => {
        const colorCode = getNewColorCode();
        return colorCode;
      });
      setColors(colors);
      setResponseYards(res.payload.yards);
    }
  };

  return (
    <>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        <Box style={{ margin: "20px 0px 20px 0px" }}>
          <Typography variant="body1" component="p">
            Total Yards:{" "}
          </Typography>
        </Box>
        <Box>
          <Typography variant="h5" component="p">
            {responseYards?.length}{" "}
          </Typography>
        </Box>
      </Grid>
      <Box
        sx={{
          // width: { xs: "100%", md: "80%" },
          height: { xs: "auto", md: "470px", xl: "520px" },
        }}
        overflow="auto"
        width="100%"
      >
        <Grid container>
          {responseYards.map((item: any, index: any) => {
            const occupiedPercentage = (item.totalOccupiedSlots / item.totalSlots) * 100;

            return (
              <>
                <Grid
                  item
                  xs={12}
                  key={index}
                  style={{ display: "flex", alignItems: "center" }}
                  className={classes.vehiclesItem}
                >
                  <Box style={{ width: "30%" }}>
                    <Typography variant="h6" component="p">
                      {item.name}
                    </Typography>
                    <Typography variant="body2" component="p">
                      {item.totalOccupiedSlots} / {item.totalSlots} Slots
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      height: "24px",
                      width: "70%",
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      backgroundColor: emptyColor as any,
                      borderRadius: "5px",
                      overflow: "hidden",
                      position: "relative",
                      marginLeft: "10px",
                    }}
                  >
                    <Box
                      sx={{
                        width: `${occupiedPercentage}%`,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        backgroundColor: colors[index] as any,
                        transition: "width 0.3s ease-in-out",
                      }}
                    />
                    <Typography
                      variant="body2"
                      component="div"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#000",
                        fontWeight: "bold",
                      }}
                    >
                      {occupiedPercentage.toFixed(2)}% Occupied
                    </Typography>
                  </Box>
                </Grid>
              </>
            );
          })}
        </Grid>
      </Box>
    </>
  );
}
